/* SEW Markaz — open the header dropdowns on hover

   Dawn builds the header menu out of <details> elements, which only open on
   click. On desktop that costs a click on the way to every category, so this
   opens them on hover instead.

   Three things this deliberately does NOT break:

   1. Touch devices. Guarded behind (hover: hover) and (pointer: fine), because
      on a phone a "hover" is really a tap, and hijacking it would leave the
      menu opening and closing unpredictably. Touch keeps Dawn's click.
   2. The keyboard. Nothing here touches focus or key handling, so tabbing to a
      menu and pressing Enter still works, and Dawn's own focusout still closes
      the menu when focus leaves it.
   3. Dawn's animations. Setting the open attribute fires the native toggle
      event, which is exactly what Dawn's DetailsDisclosure listens for, so the
      submenu still animates in rather than snapping.
*/

(function () {
  'use strict';

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!canHover.matches) return;

  // Leaving the summary to reach the submenu below it takes the cursor across a
  // small gap. Closing instantly would make the menu impossible to use, so the
  // close is held back briefly.
  var CLOSE_DELAY = 140;

  function bind(menu) {
    var details = menu.querySelector('details');
    if (!details) return;

    var summary = details.querySelector('summary');
    if (!summary) return;

    var closeTimer = null;
    var openedByHover = false;

    function open() {
      if (details.hasAttribute('open')) return;
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      openedByHover = true;
    }

    function close() {
      if (!details.hasAttribute('open')) return;
      // Do not yank the menu shut while someone is tabbing through it.
      if (details.contains(document.activeElement)) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
      openedByHover = false;
    }

    menu.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      open();
    });

    menu.addEventListener('mouseleave', function () {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(close, CLOSE_DELAY);
    });

    // Without this, clicking a heading that hover already opened would close it
    // again, which reads as the menu fighting the cursor.
    summary.addEventListener('click', function (event) {
      if (openedByHover && details.hasAttribute('open')) {
        event.preventDefault();
        openedByHover = false;
      }
    });

    details.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') openedByHover = false;
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The sticky header re-renders itself on scroll in some Dawn versions, and
  // the theme editor re-renders the section on every setting change. Both
  // replace the menu nodes, so the handlers have to be attached again.
  document.addEventListener('shopify:section:load', init);
})();
